/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import antiburnOsd from './antiburnosd/antiburnosd.reducers';
import appl from './appl/appl.reducers';
import biaxialWidget from './biaxialwidget/biaxialwidget.reducers';
import collectionScreen from './collectionscreen/collectionscreen.reducers';
import grid from './grid/grid.reducers';
import enterChannelNumber from './guide/enterchannelnumber/enterchannelnumber.reducers';
import filteredGuide from './guide/filteredguide/filteredguide.reducers';
import gridGuide from './guide/guide.reducers';
import guideHighlight from './guide/guidehighlight/guidehighlight.reducers';
import turboScroll from './guide/turboscroll/turboscroll.reducers';
import healthStats from './healthstats/systemhealthstats.reducers';
import homeScreen from './homescreen/homescreen.reducers';
import infocard from './infocard/infocard.reducers';
import inputFactory from './inputfactory/inputfactory.reducers';
import interactiveLayer from './interactivelayer/interactiveLayer.reducers';
import list from './list/list.reducers';
import listViewScreen from './listscreenview/listviewscreen.reducers';
import myShows from './myshows/myshows.reducers';
import channelOptionsOverlay from './overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import overlayHighlight from './overlay/overlayhighlight/overlayhighlight.reducers';
import pcPinOverlay from './overlay/pcpinoverlay/pcpinoverlay.reducers';
import overlayDialog from './overlaydialog/overlaydialog.reducers';
import programScreen from './programscreen/programscreen.reducers';
import recordingsStatus from './recordings/recordings.reducers';
import screens from './screens/screens.reducers';
import seasonPicker from './seasonpicker/seasonpicker.reducers';
import account from './settings/account/account.reducers';
import help from './settings/help/help.reducers';
import pcHelp from './settings/help/pchelp/pchelp.reducers';
import hideAdultContent from './settings/hideadultcontent/hideadultcontent.reducers';
import mainSettings from './settings/mainsettings/mainsettings.reducers';
import manage from './settings/manage/manage.reducers';
import onePassManager from './settings/onepassmanager/onepassmanager.reducers';
import parentalControls from './settings/parentalcontrols/parentalcontrols.reducers';
import setRatingLimits from './settings/parentalcontrols/setratinglimits/setratinglimits.reducers';
import recordingActivity from './settings/recordingactivity/recordingactivity.reducers';
import todoList from './settings/todolist/todolist.reducers';
import myShowsUserSettings from './settings/userpreferences/myshowsoptionsmenu/myshowsoptionsmenu.reducers';
import onePassAndRecordingOptions from './settings/userpreferences/onepassandrecordings/onepassandrecordings.reducers';
import userPrefAutoplayNextEpisode from './settings/userpreferences/userprefautoplaynextepisode/userprefautoplaynextepisode.reducers';
import userPreferences from './settings/userpreferences/userpreferences.reducers';
import userPrefMenuLanguage from './settings/userpreferences/userprefmenulanguage/userprefmenulanguage.reducers';
import userPrefVideoWindow from './settings/userpreferences/userprefvideowindow/userprefvideowindow.reducers';
import sidebarNavigationMenu from './sidebarnavigationmenu/sidebarnavigationmenu.reducers';
import signin from './signin/signin.reducers';
import spinner from './spinner/spinner.reducers';
import toastMessage from './toastmessage/toastmessage.reducers';
import urlChangeEvents from './urlchangeevents/urlchangeevents.reducers';
import streamingRestriction from './videoplayer/streamingrestriction/streamingrestriction.reducers';
import videoDebugOverlay from './videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import videoPlayer from './videoplayer/videoplayer.reducers';
import videoPlayerState from './videoplayer/videoplayerstate/videoplayerstate.reducers';
import infoBanner from './videoplayerui/infobanner/infobanner.reducers';
import oneLineGuide from './videoplayerui/onelineguide/onelineguide.reducers';
import errorOsd from './videoplayerui/osd/osd.reducers';
import visibilityEvents from './visibilityevents/visibilityevents.reducers';
import vodBrowseMainScreen from './vodbrowsemainscreen/vodbrowsemainscreen.reducers';
import whisper from './whisper/whisper.reducer';

const RootReducer = {
    account,
    antiburnOsd,
    appl,
    biaxialWidget,
    channelOptionsOverlay,
    collectionScreen,
    enterChannelNumber,
    errorOsd,
    filteredGuide,
    grid,
    gridGuide,
    guideHighlight,
    healthStats,
    help,
    hideAdultContent,
    homeScreen,
    infoBanner,
    infocard,
    inputFactory,
    interactiveLayer,
    list,
    listViewScreen,
    mainSettings,
    manage,
    myShows,
    myShowsUserSettings,
    oneLineGuide,
    onePassAndRecordingOptions,
    onePassManager,
    overlayDialog,
    overlayHighlight,
    parentalControls,
    pcHelp,
    pcPinOverlay,
    programScreen,
    recordingsStatus,
    screens,
    seasonPicker,
    setRatingLimits,
    sidebarNavigationMenu,
    signin,
    spinner,
    streamingRestriction,
    toastMessage,
    todoList,
    recordingActivity,
    turboScroll,
    urlChangeEvents,
    userPreferences,
    userPrefAutoplayNextEpisode,
    userPrefMenuLanguage,
    userPrefVideoWindow,
    videoDebugOverlay,
    videoPlayer,
    videoPlayerState,
    visibilityEvents,
    vodBrowseMainScreen,
    whisper,
};

export default RootReducer;
